import { createAction, props } from "@ngrx/store";

export const setCourseId = createAction('[Course] Set Course Id',props<{courseId:string}>())